export * from '@primeuix/themes/nora/accordion';
export { default } from '@primeuix/themes/nora/accordion';
